import { Data2 } from "../../../../../features/data-types"
import { ModalId, O, useLocalStorageActions, useUIActions } from "../../../../../features/ui"
import { toList } from "../../../../../utils/listUtils"
import { IdentifierType } from "../../../../system"
import { useCustomerService } from "../../../services/customerService"

export const useActions = () => {
    const { openModal, closeModal } = useUIActions()
    const { saveNewCustomerData } = useLocalStorageActions()
    const { quickCreateCustomer } = useCustomerService()
    
    const submitCustomer = async (
        data: Data2,
        identifierType: IdentifierType,
        identifier: number,
        creditLimit?: number,
        creditDays?: number
    ) => {
        const { name, category, customerTypeId, vatCondition, phone, email, creditAccount } = data
        const customerData: Data2 = {
            name,
            category,
            identifierType,
            identifier,
            customerTypeId,
            vatCondition,
            phones: toList(phone as O<number>),
            emails: toList(email as O<string>)
        }
        const creditAccountData: O<Data2> = creditAccount ? {
            creditLimit,
            creditDays
        } : undefined

        saveNewCustomerData({ customerData, creditAccountData })

        if (!data.phone && !data.email) {
            closeModal(ModalId.QUICK_FORM)
            openModal(ModalId.CUSTOMER_WARNING)
        } else {
            return quickCreateCustomer()
        }
    }

    return {
        submitCustomer
    }
}
